import { FileResponse } from "../http-client";

function getMimeType(filename: string): string {
  const extension = filename.toLowerCase().split(".").pop();

  switch (extension) {
    case "zip":
      return "application/zip";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "xls":
      return "application/vnd.ms-excel";
    case "csv":
      return "text/csv";
    default:
      return "application/octet-stream";
  }
}

export function saveFile({ blob, filename }: FileResponse) {
  const decodedFilename = decodeURIComponent(filename);
  const mimeType = getMimeType(decodedFilename);

  const url = window.URL.createObjectURL(
    new Blob([blob], {
      type: mimeType,
    }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", decodedFilename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
